import { render } from "./ButtonUI.vue?vue&type=template&id=31c9dba5"
import script from "./ButtonUI.vue?vue&type=script&lang=js"
export * from "./ButtonUI.vue?vue&type=script&lang=js"

import "./ButtonUI.vue?vue&type=style&index=0&id=31c9dba5&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__